import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';


import arCommon from './locales/ar/common.json';
import enCommon from './locales/en/common.json';

import enContact from './locales/en/contact.json';
import arContact from './locales/ar/contact.json';


i18n
    .use(Backend)
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        fallbackLng: 'ar',
        supportedLngs: ["en", "ar"],
        resources: {
            ar: {
                common: arCommon,
                contact: arContact,
            },
            en: {
                common: enCommon,
                contact: enContact,
            }
        },
        ns: ['common', "contact"],
        defaultNS: "common",
        // debug: process.env.NODE_ENV === "development",
    });


export default i18n;